import { render, staticRenderFns } from "./emailForPayModal.vue?vue&type=template&id=04aea018"
import script from "./emailForPayModal.vue?vue&type=script&lang=js"
export * from "./emailForPayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports